import React from "react";
import CryptoJS from "crypto-js";
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import { NavLink } from "react-router-dom";
import cx from "classnames";
import Cookies from "universal-cookie";
import { Redirect } from "react-router-dom";
import API from "@aws-amplify/api";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";
import Icon from "@material-ui/core/Icon";
import { getCurrentJwt } from "../../util/jwt/decryptToken";
// core components
import HeaderLinks from "components/Header/HeaderLinks.jsx";

import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

import avatar from "assets/img/account_circle.svg";
import { Auth } from "aws-amplify";
import handlePowerBiLogin from "../../util/powerBi/handlePowerBiLogin";
import { clearIndexedDB, saveData } from "../../util/dataCaching/cmpStorageManager";

const cookies = new Cookies();
let apiName = process.env.REACT_APP_AMPLIFY_API;

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {
  componentDidMount() {
    //setTimeout(function() {}.bind(this), 2000);
    // if (navigator.platform.indexOf("Win") > -1) {
    //   ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
    //     suppressScrollX: true,
    //     suppressScrollY: false
    //   });
    // }
  }
  // componentWillUnmount() {
  //   if (navigator.platform.indexOf("Win") > -1) {
  //     ps.destroy();
  //   }
  // }

  render() {
    const { className, user, headerLinks, links } = this.props;
    return (
      <div
        style={{ overflowY: "auto" }}
        className={className}
        ref="sidebarWrapper"
      >
        {user}
        {headerLinks}
        {links}
      </div>
    );
  }
}

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      openAvatarMulti: false,
      profile: false,
      openTemplate: this.activeRoute("/template"),
      openInsights: this.activeRoute("/insights"),
      miniActive: true,
      // cSwitch: JSON.parse(
      //   CryptoJS.AES.decrypt(
      //     localStorage.getItem("clientswitch"),
      //     process.env.REACT_APP_PASS
      //   ).toString(CryptoJS.enc.Utf8)
      // ),
      cSwitch: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientswitch"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ).sort(function(client1, client2) {
        if (client1.cname < client2.cname) {
          return -1;
        }
        if (client1.cname > client2.cname) {
          return 1;
        }
        return 0;
      }),
    };
    this.activeRoute.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }
  // verifies if routeName is the one active (in browser input)
  switchClients(cid, conid) {
    let path = "/users";
    let custHeaders = {
      headers: {
        userId: JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("userId"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ),
      },
    };
    //Gets the user Id from the localstorage and fectches the user record from cmp-users
    API.get(apiName, path, custHeaders)
      .then((response) => {
        let userDetails = response[0];
        let gDetails = JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("groupDetails"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        );
        let swClient = gDetails.filter(
          (obj) => obj.settings.cmp.clientId == cid
        );
        //let swConcept = gDetails.filter(obj=>obj.id == conid);
        let cName = swClient[0]["parentName"];
        let cDb = cName + "_refined";
        userDetails["concept"] = swClient[0]["id"];
        userDetails["clientId"] = cid;
        userDetails["userDashboard"] = {
          app_id: swClient[0]["settings"]["qlikSense"]["dashboardAppId"],
          sheet_id: swClient[0]["settings"]["qlikSense"]["dashboardSheetId"],
        };
        let channelDisplayObj = {};
        let myInit1 = {
          headers: {
            userid: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("userId"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ),
          },
          body: userDetails,
        };
        //Overrides the existing Row in the audience table
        API.post(apiName, path, myInit1)
          .then(async (response) => {
            for (let n in swClient[0]["settings"]["channels"]) {
              channelDisplayObj[swClient[0]["settings"]["channels"][n]["id"]] =
                swClient[0]["settings"]["channels"][n]["display"];
            }
            localStorage.setItem(
              "channelsDisObj",
              CryptoJS.AES.encrypt(
                JSON.stringify(channelDisplayObj),
                process.env.REACT_APP_PASS
              ).toString()
            );
            localStorage.setItem(
              "clientId",
              CryptoJS.AES.encrypt(JSON.stringify(cid), process.env.REACT_APP_PASS).toString()
            );
            localStorage.setItem(
              "conceptName",
              CryptoJS.AES.encrypt(
                JSON.stringify(swClient[0]["name"]),
                process.env.REACT_APP_PASS
              ).toString()
            );
            if (swClient[0]["activeLocations"] !== undefined) {
              localStorage.setItem(
                "numberOfActiveLocations",
                CryptoJS.AES.encrypt(
                  JSON.stringify(swClient[0]["activeLocations"]),
                  process.env.REACT_APP_PASS
                ).toString()
              );
            } else {
              localStorage.setItem(
                "numberOfActiveLocations",
                CryptoJS.AES.encrypt(
                  JSON.stringify(""),
                  process.env.REACT_APP_PASS
                ).toString()
              );
            }
            if (swClient[0]["suppressionCustId"] !== undefined) {
              localStorage.setItem(
                "suppressionCustId",
                CryptoJS.AES.encrypt(
                  JSON.stringify(swClient[0]["suppressionCustId"]),
                  process.env.REACT_APP_PASS
                ).toString()
              );
            } else {
              localStorage.setItem(
                "suppressionCustId",
                CryptoJS.AES.encrypt(
                  JSON.stringify(""),
                  process.env.REACT_APP_PASS
                ).toString()
              );
            }
            localStorage.setItem(
              "channels",
              CryptoJS.AES.encrypt(
                JSON.stringify(
                  swClient[0]["settings"]["channels"].map((a) => a.id)
                ),
                process.env.REACT_APP_PASS
              ).toString()
            );
            
            // CACHING - Client Record
            await saveData("cmp", "cmp", "clientConfig", swClient[0])

            // CACHING - Insights
            if(swClient[0].hasOwnProperty('htmlReporting')) {
              if(swClient[0].htmlReporting.hasOwnProperty('insights')) {
                window.sessionStorage.setItem('html-reporting-insights', JSON.stringify(swClient[0].htmlReporting))
              } 
            }

            // // POWERBI - INTEGRATION
            // if(swClient[0]["settings"]["powerBiDashboard"] !== null && swClient[0]["settings"]["powerBiDashboard"] !== undefined) {
            //   await handlePowerBiLogin(swClient[0]["settings"]["powerBiDashboard"], getCurrentJwt()).then(data=>data)
            //   localStorage.setItem("powerBiInfo",CryptoJS.AES.encrypt(JSON.stringify(swClient[0]["settings"]["powerBiDashboard"]),process.env.REACT_APP_PASS).toString());
            // }
            // else {
            //   localStorage.removeItem("powerBiInfo")
            //   localStorage.removeItem("powerBiInsights")
            // }

            localStorage.setItem(
              "dappId",
              CryptoJS.AES.encrypt(
                JSON.stringify(
                  swClient[0]["settings"]["qlikSense"]["dashboardAppId"]
                ),
                process.env.REACT_APP_PASS
              ).toString()
            );
            localStorage.setItem(
              "dsheetId",
              CryptoJS.AES.encrypt(
                JSON.stringify(
                  swClient[0]["settings"]["qlikSense"]["dashboardSheetId"]
                ),
                process.env.REACT_APP_PASS
              ).toString()
            );
            localStorage.setItem(
              "model",
              CryptoJS.AES.encrypt(
                JSON.stringify(swClient[0]["model"]),
                process.env.REACT_APP_PASS
              ).toString()
            );
            localStorage.setItem(
              "licensedModules",
              CryptoJS.AES.encrypt(
                JSON.stringify(swClient[0]["licensedModules"]),
                process.env.REACT_APP_PASS
              ).toString()
            );
            localStorage.setItem(
              "globalFilter",
              CryptoJS.AES.encrypt(
                JSON.stringify("ca.geo_concept = '" + swClient[0]["id"] + "'"),
                process.env.REACT_APP_PASS
              ).toString()
            );
            localStorage.setItem(
              "logoName",
              CryptoJS.AES.encrypt(
                JSON.stringify(cName),
                process.env.REACT_APP_PASS
              ).toString()
            );
            localStorage.setItem(
              "custDb",
              CryptoJS.AES.encrypt(JSON.stringify(cDb), process.env.REACT_APP_PASS).toString()
            );
            localStorage.setItem(
              "geo_active",
              CryptoJS.AES.encrypt(
                JSON.stringify("true"),
                process.env.REACT_APP_PASS
              ).toString()
            );

            // Qlik APP Reports
            var obj = {
              method: "GET",
              headers: {
                Authorization: getCurrentJwt(),
              },
            };
            fetch(
              process.env.REACT_APP_QLIK_API +
                "apps?cookie=" +
                localStorage.getItem("cookie"),
              obj
            )
              .then((res) => res.json())
              .then(
                (result) => {
                  var myMap = new Object();
                  //var myMap = Object.create(null);

                  result["data"].map((list, idx) => {
                    myMap[list.id] = list.attributes.name;
                    // myMap.set(list.id, list.attributes.name);
                  });

                  //myMap["length"] = result["data"].length;
                  localStorage.setItem(
                    "appData",
                    CryptoJS.AES.encrypt(
                      JSON.stringify(myMap),
                      process.env.REACT_APP_PASS
                    ).toString()
                  );
                  this.props.history.push("/dashboard");
                  window.location.reload(true);
                },
                (error) => {}
              );
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error.response);
      });
  }
  async handleLogout() {
    var obj = {
      method: "GET",
      headers: { Authorization: getCurrentJwt() },
    };    
    // Clear from Session Manager
    clearIndexedDB('cmp')
    
    await fetch(
      process.env.REACT_APP_QLIK_API +
        "logout?cookie=" +
        cookies.get("X-Qlik-Session-CMP"),
      obj
    )
      .then((res) => res.json())
      .then(
        (result) => {
          Auth.signOut();
          localStorage.clear();
          this.props.history.push("/login");
          cookies.remove("Qlik-Ticket-CMP");
          cookies.remove("X-Qlik-Session-CMP");
          cookies.remove("X-Qlik-Session");
          cookies.remove("Qlik-Ticket-CMP", { path: "/", domain: ".cmp.io" });
          cookies.remove("X-Qlik-Session-CMP", {
            path: "/",
            domain: ".cmp.io",
          });
          console.log(result);
        },
        (error) => {
          Auth.signOut();
          localStorage.clear();
          this.props.history.push("/login");
          cookies.remove("Qlik-Ticket-CMP");
          cookies.remove("X-Qlik-Session-CMP");
          cookies.remove("X-Qlik-Session");
          cookies.remove("Qlik-Ticket-CMP", { path: "/", domain: ".cmp.io" });
          cookies.remove("X-Qlik-Session-CMP", {
            path: "/",
            domain: ".cmp.io",
          });
          console.log(error);
        }
      );
    //cookies.remove("Qlik-Ticket-CMP", { path: "/", domain: ".cmp.io" });
    /*cookies.remove("X-Qlik-Session-CMP", {
      path: "/",
      domain: ".cmp.io"
    });*/
  }

  openProfile() {
    this.setState({
      profile: true,
    });
  }
  activeRoute(routeName) {
    return (new RegExp('.*'+routeName + '$')).test(this.props.location.pathname);
  }
  openCollapse(collapse) {
    var st = {};
    st[collapse] = !this.state[collapse];
    this.setState(st);
  }
  render() {
    const {
      classes,

      logo,

      routes,
      bgColor,
      rtlActive,
    } = this.props;
    const itemText =
      classes.itemText +
      " " +
      cx({
        [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
        [classes.itemTextMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.itemTextRTL]: rtlActive,
      });
    const collapseItemText =
      classes.collapseItemText +
      " " +
      cx({
        [classes.collapseItemTextMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.collapseItemTextMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.collapseItemTextRTL]: rtlActive,
      });
    const userWrapperClass =
      classes.user +
      " " +
      cx({
        [classes.whiteAfter]: bgColor === "white",
      });
    const caret =
      classes.caret +
      " " +
      cx({
        [classes.caretRTL]: rtlActive,
      });
    const collapseItemMini =
      classes.collapseItemMini +
      " " +
      cx({
        [classes.collapseItemMiniRTL]: rtlActive,
      });
    const photo =
      classes.photo +
      " " +
      cx({
        [classes.photoRTL]: rtlActive,
      });
    if (this.state.profile) {
      return <Redirect to="/userProfile" />;
    }
    var user = (
      <div className={userWrapperClass}>
        <div className={photo}>
          <img src={avatar} className={classes.avatarImg} alt="..." />
        </div>
        <List className={classes.list}>
          <ListItem className={classes.item + " " + classes.userItem}>
            <NavLink
              to={"#"}
              className={classes.itemLink + " " + classes.userCollapseButton}
              onClick={() => this.openCollapse("openAvatar")}
            >
              <ListItemText
                primary={
                  localStorage.getItem("given_name") != null
                    ? JSON.parse(
                        CryptoJS.AES.decrypt(
                          localStorage.getItem("given_name"),
                          process.env.REACT_APP_PASS
                        ).toString(CryptoJS.enc.Utf8)
                      )
                    : ""
                }
                secondary={
                  <b
                    className={
                      caret +
                      " " +
                      classes.userCaret +
                      " " +
                      (this.state.openAvatar ? classes.caretActive : "")
                    }
                  />
                }
                disableTypography={true}
                className={itemText + " " + classes.userItemText}
              />
            </NavLink>
            <Collapse in={this.state.openAvatar} unmountOnExit>
              <List className={classes.list + " " + classes.collapseList}>
                <ListItem
                  className={classes.collapseItem}
                  onClick={() => this.openProfile()}
                >
                  <NavLink
                    to="#"
                    className={
                      classes.itemLink + " " + classes.userCollapseLinks
                    }
                  >
                    <span className={collapseItemMini}>MP</span>
                    <ListItemText
                      primary={"My Profile"}
                      disableTypography={true}
                      className={collapseItemText}
                    />
                  </NavLink>
                </ListItem>
                {/* <ListItem className={classes.collapseItem}>
                  <NavLink
                    to="#"
                    className={
                      classes.itemLink + " " + classes.userCollapseLinks
                    }
                  >
                    <span className={collapseItemMini}>
                      <i className="material-icons">keyboard_arrow_right</i>
                    </span>
                    <ListItemText
                      primary={"Edit Profile"}
                      disableTypography={true}
                      className={collapseItemText}
                    />
                  </NavLink>
                </ListItem> */}
                {/* <ListItem 
                  className={classes.collapseItem}
                  onClick={() => this.openSettings()}
                >
                  <NavLink
                    to="#"
                    className={
                      classes.itemLink + " " + classes.userCollapseLinks
                    }
                  >
                    <span className={collapseItemMini}>
                      <i className="material-icons">keyboard_arrow_right</i>
                    </span>
                    <ListItemText
                      primary={"Settings"}
                      disableTypography={true}
                      className={collapseItemText}
                    />
                  </NavLink>
                </ListItem> */}
                <ListItem className={classes.item + " " + classes.userItem}>
                  <NavLink
                    to={"#"}
                    className={
                      classes.itemLink + " " + classes.userCollapseLinks
                    }
                    onClick={() => this.openCollapse("openAvatarMulti")}
                  >
                    <span className={collapseItemMini}>
                      <i className="material-icons">swap_horizontal_circle</i>
                    </span>
                    <ListItemText
                      primary={"Switch Concept"}
                      secondary={
                        <b
                          className={
                            caret +
                            " " +
                            classes.userCaret +
                            " " +
                            (this.state.openAvatarMulti
                              ? classes.caretActive
                              : "")
                          }
                        />
                      }
                      disableTypography={true}
                      className={itemText + " " + classes.userItemText}
                    />
                  </NavLink>
                  <Collapse in={this.state.openAvatarMulti} unmountOnExit>
                    <List className={classes.list + " " + classes.collapseList}>
                      {this.state.cSwitch.map((prop, key) => {
                        return (
                          <ListItem
                            className={classes.collapseItem}
                            onClick={() =>
                              this.switchClients(prop.cid, prop.conid)
                            }
                          >
                            <NavLink
                              to="#"
                              className={
                                classes.itemLink +
                                " " +
                                classes.userCollapseLinks
                              }
                            >
                              <span className={collapseItemMini}>
                                {prop.cname.slice(0, 3)}
                              </span>
                              <ListItemText
                                primary={prop.cname}
                                disableTypography={true}
                                className={collapseItemText}
                              />
                            </NavLink>
                          </ListItem>
                        );
                      })}
                    </List>
                  </Collapse>
                </ListItem>

                <ListItem
                  className={classes.collapseItem}
                  onClick={this.handleLogout}
                >
                  <NavLink
                    to="#"
                    className={
                      classes.itemLink + " " + classes.userCollapseLinks
                    }
                  >
                    <span className={collapseItemMini}>
                      <i className="material-icons">exit_to_app</i>
                    </span>
                    <ListItemText
                      primary={"Log Out"}
                      disableTypography={true}
                      className={collapseItemText}
                    />
                  </NavLink>
                </ListItem>
              </List>
            </Collapse>
          </ListItem>
        </List>
      </div>
    );
    var links = (
      <List className={classes.list} style={{ maxHeight: "100%" }}>
        {routes.map((prop, key) => {
          if (prop.redirect || prop.isHidden) {
            return null;
          }
          if (prop.collapse) {
            const navLinkClasses =
              classes.itemLink +
              " " +
              cx({
                [" " + classes.collapseActive]: this.activeRoute(prop.path),
              });
            const itemText =
              classes.itemText +
              " " +
              cx({
                [classes.itemTextMini]:
                  this.props.miniActive && this.state.miniActive,
                [classes.itemTextMiniRTL]:
                  rtlActive && this.props.miniActive && this.state.miniActive,
                [classes.itemTextRTL]: rtlActive,
              });
            const collapseItemText =
              classes.collapseItemText +
              " " +
              cx({
                [classes.collapseItemTextMini]:
                  this.props.miniActive && this.state.miniActive,
                [classes.collapseItemTextMiniRTL]:
                  rtlActive && this.props.miniActive && this.state.miniActive,
                [classes.collapseItemTextRTL]: rtlActive,
              });
            const itemIcon =
              classes.itemIcon +
              " " +
              cx({
                [classes.itemIconRTL]: rtlActive,
              });
            const caret =
              classes.caret +
              " " +
              cx({
                [classes.caretRTL]: rtlActive,
              });
            return (
              <ListItem key={key} className={classes.item}>
                <NavLink
                  to={"#"}
                  className={navLinkClasses}
                  onClick={() => this.openCollapse(prop.state)}
                >
                  <ListItemIcon className={itemIcon}>
                    {typeof prop.icon === "string" ? (
                      <Icon>{prop.icon}</Icon>
                    ) : (
                      <prop.icon />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={prop.name}
                    secondary={
                      <b
                        className={
                          caret +
                          " " +
                          (this.state[prop.state] ? classes.caretActive : "")
                        }
                      />
                    }
                    disableTypography={true}
                    className={itemText}
                  />
                </NavLink>
                <Collapse in={this.state[prop.state]} unmountOnExit>
                  <List className={classes.list + " " + classes.collapseList}>
                    {prop.views.map((prop, key) => {
                      if (prop.redirect) {
                        return null;
                      }
                      const navLinkClasses =
                        classes.collapseItemLink +
                        " " +
                        cx({
                          [" " + classes["secondary"]]: this.activeRoute(
                            prop.path
                          ),
                        });
                      const collapseItemMini =
                        classes.collapseItemMini +
                        " " +
                        cx({
                          [classes.collapseItemMiniRTL]: rtlActive,
                        });
                      return (
                        <ListItem key={key} className={classes.collapseItem}>
                          <NavLink to={prop.path} className={navLinkClasses}>
                            <span className={collapseItemMini}>
                              {prop.mini}
                            </span>
                            <ListItemText
                              primary={prop.name}
                              disableTypography={true}
                              className={collapseItemText}
                            />
                          </NavLink>
                        </ListItem>
                      );
                    })}
                  </List>
                </Collapse>
              </ListItem>
            );
          }
          const navLinkClasses =
            classes.itemLink +
            " " +
            cx({
              [" " + classes["secondary"]]: this.activeRoute(prop.path),
            });
          const itemText =
            classes.itemText +
            " " +
            cx({
              [classes.itemTextMini]:
                this.props.miniActive && this.state.miniActive,
              [classes.itemTextMiniRTL]:
                rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.itemTextRTL]: rtlActive,
            });
          const itemIcon =
            classes.itemIcon +
            " " +
            cx({
              [classes.itemIconRTL]: rtlActive,
            });
          return (
            <ListItem key={key} className={classes.item}>
              <NavLink to={prop.path} className={navLinkClasses}>
                <ListItemIcon className={itemIcon}>
                  {typeof prop.icon === "string" ? (
                    <Icon>{prop.icon}</Icon>
                  ) : (
                    <prop.icon />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={prop.name}
                  disableTypography={true}
                  className={itemText}
                />
              </NavLink>
            </ListItem>
          );
        })}
      </List>
    );

    // const logoNormal =
    //   classes.logoNormal +
    //   " " +
    //   cx({
    //     [classes.logoNormalSidebarMini]:
    //       this.props.miniActive && this.state.miniActive,
    //     [classes.logoNormalSidebarMiniRTL]:
    //       rtlActive && this.props.miniActive && this.state.miniActive,
    //     [classes.logoNormalRTL]: rtlActive
    //   });
    const logoMini =
      classes.logoMini +
      " " +
      cx({
        [classes.logoMiniRTL]: rtlActive,
      });
    const logoClasses =
      classes.logo +
      " " +
      cx({
        [classes.whiteAfter]: bgColor === "white",
      });
    var brand = (
      <div className={logoClasses}>
        <a className={logoMini}>
          <img src={logo} alt="logo" className={classes.img} />
        </a>
      </div>
    );
    const drawerPaper =
      classes.drawerPaper +
      " " +
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.drawerPaperRTL]: rtlActive,
      });
    const sidebarWrapper =
      classes.sidebarWrapper +
      " " +
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.sidebarWrapperWithPerfectScrollbar]: false,
          // navigator.userAgentData.platform.indexOf("Win") > -1,
      });
    return (
      <div ref="mainPanel">
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={rtlActive ? "left" : "right"}
            open={this.props.open}
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"],
            }}
            onClose={this.props.handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              user={user}
              headerLinks={<HeaderLinks rtlActive={rtlActive} />}
              links={links}
            />
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            onMouseOver={() => this.setState({ miniActive: false })}
            onMouseOut={() => this.setState({ miniActive: true })}
            anchor={rtlActive ? "right" : "left"}
            variant="permanent"
            open
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"],
            }}
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              user={user}
              links={links}
            />
          </Drawer>
        </Hidden>
      </div>
    );
  }
}

Sidebar.defaultProps = {
  bgColor: "blue",
  color: "white",
};

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.oneOf(["white", "black", "blue"]),
  rtlActive: PropTypes.bool,
  color: PropTypes.oneOf([
    "white",
    "red",
    "orange",
    "green",
    "blue",
    "purple",
    "rose",
    "secondary",
  ]),
  logo: PropTypes.string,
  logoText: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
};

export default withStyles(sidebarStyle)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx